import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function EmerGencyPopUp({ closePopup }) {
    const { t } = useTranslation("clientOnDemand");





    return (
        <div>
            <div
                id="EmerGencyPopUp"
                class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
                data-backdrop="static"
            >
                <div class="modal-dialog modal-lg modal-dialog-preview text-center">
                    <div class="modal-content p-5">
                        <h3>{t("cache.intro")}
                            <br />  {t("cache.followShortcuts")}
                        </h3>
                        <br />
                        <br />
                        <br />


                        <h3 className="font-size-22 text-left text-underline"> {t("cache.mac")}</h3>

                        <br />


                        <h3 className="font-size-22 text-left  text-underline">    {t("cache.windowsShortcut")}</h3>


                        <div id="msform">

                            <input
                                type="button"
                                name="Close"
                                class="next action-button m-3"
                                value={t("actions.close")}
                                onClick={closePopup}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
